import React from 'react';
import { Modal, Input, Button, message } from 'antd';


class AddLog extends React.Component {

  state = {
    pass: "",
    pass2: ""
  }

  changePass = () => {
    const { pass, pass2 } = this.state
    const { t } = this.props
    if (pass !== pass2) {
      message.error(t('Passwords do not match!'))
    } else {
      this.props.changePass(this.state.pass)
    }
  }

  render() {

    let { color, t } = this.props

    if (!color) {
      color = '#4A90E2'
    }

    const styles = {
      title: {
        color: color,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        marginTop: 20
      },
      input: {
        width: '100%',
        border: `1px solid ${color}`,
        height: 32,
        borderRadius: 20,
        paddingLeft: 10,
        fontSize: 17,
        marginTop: 10
      },
      button: {
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        marginTop: 20
      },
    }

    return (
      <Modal
        visible={this.props.open}
        footer={null}
        wrapClassName='addLog'
        closable={false}
        width={700}
      >
        <h1 style={{color: color, fontSize: 22, fontFamily: 'Arial Rounded MT Bold', marginTop: 20, textAlign: 'center'}}>{t('Set Password')}</h1>
        <h3 className='logTitle' style={styles.title}>{t('Please type in the password you would like to use to log into Tracker Apps.')}</h3>
        <input style={styles.input} type="password" placeholder="Password" onChange={(e) => this.setState({pass: e.target.value})} value={this.state.pass}/>
        <input style={styles.input} type="password" placeholder="Repeat Password" onChange={(e) => this.setState({pass2: e.target.value})} value={this.state.pass2}/>
        <Button style={styles.button} onClick={() => this.changePass()}>{t('Save')}</Button>
      </Modal>
    )
  }
}

export default AddLog;



// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.jsx